{{! {{hide-application-header}}
{{! {{hide-application-sidebar}}
{{body-class 'siwe-login-page'}}
{{hideApplicationHeaderButtons 'search' 'login' 'signup' 'menu'}}
{{hideApplicationSidebar}}
{{! {{bodyClass "login-page"}}
{{bodyClass 'siwe-login-page'}}

<form
  id='siwe-sign'
  method='POST'
  action='/auth/siwe/callback'
  style='display: none;'
>
  <textarea id='eth_message' name='eth_message'></textarea>
  <textarea id='eth_signature' name='eth_signature'></textarea>
</form>

<div id='siwe-mount' class='siwe-mount'></div>